import React, {Component} from "react";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as config from "../../../constants/config";

import imgClose from "../../../resources/img/svgicons/close-black.svg";
import imgCancel from "../../../resources/img/svgicons/cancel.svg";
import imgPurge from "../../../resources/img/svgicons/purge.svg";

export default class SmartPurgeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedChannels: []
        };
    }

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleToggleSelectChannelClick = (event) => {
        let channel = this.getChannelFromList(Number(event.target.dataset.id));

        if (channel !== null) {
            if (this.isChannelSelected(channel)) {
                this.setState({
                    selectedChannels: this.state.selectedChannels.filter((selected) => selected.id !== channel.id)
                });
            } else {
                this.setState({
                    selectedChannels: [...this.state.selectedChannels, channel]
                });
            }
        }
    };

    handleSelectAllClick = () => {
        this.setState({
            selectedChannels: this.getEnabledChannels()
        });
    };

    handleClearClick = () => {
        this.setState({
            selectedChannels: []
        });
    };

    getEnabledChannels = () => {
        return this.props.channelList.filter((channel) => channel.enabled);
    };

    getChannelFromList = (channelId) => {
        let channel;
        for (channel of this.props.channelList) {
            if (channel.id === channelId) {
                return channel;
            }
        }

        return null;
    };

    isChannelSelected = (channel) => {
        if (this.state.selectedChannels.length === 0) {
            return false;
        }

        let selectedChannel;
        for (selectedChannel of this.state.selectedChannels) {
            if (selectedChannel.id === channel.id) {
                return true;
            }
        }

        return false;
    };

    getColorantByChannel = (channel) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (channel.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    getChannelBoxClass = (channel) => {
        if (this.isChannelSelected(channel)) {
            return "colorant-box active";
        }

        return "colorant-box";
    };

    getChannelBox = (channel) => {
        let colorant = channel.colorant;
        if (colorant !== null && colorant.rgb === null) {
            colorant = this.getColorantByChannel(channel);
        }

        if (!channel.enabled) {
            return (
                <div key={channel.id} className="colorant-box disabled">
                    <div key={channel.id} className="color-primary canister-index">
                        {channel.id}
                    </div>
                    <div
                        className="colorant-square"
                        style={{backgroundColor: colorant !== null ? colorant.rgb : config.DEFAULT_RGB}}
                    />
                    <div className="colorant-code">{colorant !== null ? colorant.name : ""}</div>
                </div>
            );
        }

        return (
            <div
                key={channel.id}
                className={this.getChannelBoxClass(channel)}
                data-id={channel.id}
                onClick={this.handleToggleSelectChannelClick}
            >
                <div
                    key={channel.id}
                    className="color-primary canister-index"
                    data-id={channel.id}
                    onClick={this.handleToggleSelectChannelClick}
                >
                    {channel.id}
                </div>
                <div
                    className="colorant-square"
                    style={{backgroundColor: colorant !== null ? colorant.rgb : config.DEFAULT_RGB}}
                    data-id={channel.id}
                />
                <div className="colorant-code" data-id={channel.id}>
                    {colorant !== null ? colorant.name : ""}
                </div>
            </div>
        );
    };

    getChannelBoxes = () => {
        let boxes = [];
        let channel;
        for (channel of this.props.channelList) {
            boxes.push(this.getChannelBox(channel));
        }

        return boxes;
    };

    handleStartPurgingClick = () => {
        let channelIndexes = this.state.selectedChannels.map((channel) => channel.id);

        if (channelIndexes.length > 0) {
            let index,
                channels = [];
            for (index of channelIndexes) {
                channels.push(Number(index));
            }

            this.props.closeModal();
            this.props.smartPurgeChannels(channels);
        }
    };

    getSelectAllButton = () => {
        if (this.state.selectedChannels.length < this.getEnabledChannels().length) {
            return (
                <button className="select-all-button btn btn-info pull-right" onClick={this.handleSelectAllClick}>
                    <Translate value="general.selectAll" />
                </button>
            );
        }

        return (
            <button className="select-all-button btn btn-info pull-right" onClick={this.handleClearClick}>
                <Translate value="general.clear" />
            </button>
        );
    };

    getStartPurgeButton = () => {
        if (this.state.selectedChannels.length > 0) {
            return (
                <button className="btn btn-info btn-purge" onClick={this.handleStartPurgingClick}>
                    <ReactSVG className="pull-left btn-icon" src={imgPurge} alt="purge" />
                    <Translate value="general.purge" />
                </button>
            );
        }

        return (
            <button className="btn btn-info btn-purge disabled">
                <ReactSVG className="pull-left btn-icon" src={imgPurge} alt="purge" />
                <Translate value="general.purge" />
            </button>
        );
    };

    render() {
        return (
            <div id="modal" className="purge-modal service-actions-modal">
                <header className="color-primary">
                    <Translate value="serviceActionsSettings.purgeChannels" />
                    <div className="modal-close" onClick={this.handleCloseModalClick}>
                        <ReactSVG src={imgClose} className="close-img" alt="close" />
                    </div>
                </header>
                <div className="modal-content">
                    <div className="row">
                        <div className="col-xs-12 colorant-select">
                            <div className="row">
                                <div className="col-xs-12 header-row">
                                    <div className="color-primary pull-left">
                                        <Translate value="general.selectChannels" />:
                                    </div>
                                    {this.getSelectAllButton()}
                                </div>
                            </div>
                            <div className="channel-list slim-scroll">{this.getChannelBoxes()}</div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 text-right modal-footer">
                    {this.getStartPurgeButton()}
                    <button onClick={this.handleCloseModalClick} className="btn btn-info btn-md action-button">
                        <ReactSVG className="pull-left action-icon" src={imgCancel} alt="cancel" />
                        <Translate value="general.cancel" />
                    </button>
                </div>
            </div>
        );
    }
}
